import {Input as InputAntd, type InputProps} from 'antd'
import type {SearchProps} from 'antd/es/input/Search'
import React from 'react'
import LabelText from '../LabelText'
import {DeleteIcon, SearchIcon} from '../svg'

const Input = (props: InputProps) => {
  return (
    <InputAntd
      prefix={props.prefix ? <LabelText inputLabel={true} text={props.prefix} /> : null}
      {...props}
      allowClear={
        typeof props.allowClear === 'object'
          ? {
              clearIcon: props.allowClear?.clearIcon || <DeleteIcon style={{display: 'block'}} />,
            }
          : props.allowClear
            ? {clearIcon: <DeleteIcon style={{display: 'block'}} />}
            : false
      }
    />
  )
}

const Search = (props: SearchProps) => {
  return <InputAntd.Search enterButton={<SearchIcon style={{display: 'block'}} />} {...props} />
}

Input.TextArea = InputAntd.TextArea
Input.Search = Search
Input.Password = InputAntd.Password
Input.OTP = InputAntd.OTP

export default Input
